import { useState, useContext } from 'react';

import { CriticalFinancePageContext } from '../CriticalFiancePage.jsx'

import { industryDetails, investmentEquityRenderFields, PSBBinvestmentEquityRenderFields } from '../../constants.jsx';
import { renderFormRow, genericPOSTDatabaseCall } from '../../helperFunctions.jsx';

async function saveEntityToDatabase(entity, usedAt) {
    return genericPOSTDatabaseCall(`/api/${usedAt}/saveEntity`, { entity }, 'entity info');
}

function InvestmentEquityModal({contextToUse, usedAt = 'cfi'}) {
    // Use the provided context or default to CriticalFinancePageContext
    const { entitySelected, messageApi, setEntitySelected } = useContext(contextToUse || CriticalFinancePageContext);
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        setSaving(true);
        messageApi.loading('Saving entity info...', 0);
        try {
            await saveEntityToDatabase({...entitySelected, id: entitySelected.cfi_id !== undefined ? entitySelected.cfi_id : entitySelected.id}, usedAt);
            messageApi.destroy();
            messageApi.success('Company info saved successfully');
        } catch (error) {
            console.error('Error saving entity info:', error);
            messageApi.destroy();
            messageApi.error('Failed to save entity info');
        }
        setSaving(false);
    };


    const handleInputChange = (event, entity, key, field) => {
        let newValue = event.target.value;

        setEntitySelected(prev => ({
            ...prev,
            [key]: newValue
        }));
    }

    const handleInputBlur = (event, entity, key, field) => {
        let newValue = event.target.value;

        if (field.regexCondition && field.errorMessage && !field.regexCondition.test(newValue)) {
            messageApi.error(field.errorMessage);
            newValue = industryDetails[entity.industry][key] || field.default || ''; // Use default value if provided
        }

        if (newValue === '') {
            messageApi.error('This field cannot be empty');
            newValue = industryDetails[entity.industry][key] || field.default || ''; // Use default value if provided
        }

        setEntitySelected(prev => ({
            ...prev,
            [key]: newValue
        }));
    }

    const fieldsToUse = usedAt === 'cfi' ? investmentEquityRenderFields : PSBBinvestmentEquityRenderFields;

    return (
        <div className="other-variables-cost financial-builder-container entity-industry-container">
            <h2>Investment & Equity Pricing</h2>
            <div className='entity-card'>
                {fieldsToUse.map(field => (renderFormRow(field, entitySelected, handleInputChange, true, handleInputBlur)))}
                <div className="flex-row bottom-actions">
                    <div className="form-row actions-row">
                        <button disabled={saving} onClick={handleSave} type="button" className="save-button">Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default InvestmentEquityModal;